'use client';
import { useEffect, useRef } from 'react';
import './PlatformHero.scss';

const PlatformHero = ({ title, highlight, text }) => {
  const wrapperRef = useRef(null);
  const innerRef = useRef(null);

  useEffect(() => {
    if (title) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const wrapper = wrapperRef.current;
    const inner = innerRef.current;
    if (!wrapper || !inner) return;

    const onScroll = () => {
      const rect = wrapper.getBoundingClientRect();
      const scrolled = Math.max(0, -rect.top);
      const total = Math.max(1, rect.height - window.innerHeight);
      const progress = Math.min(1, scrolled / total);

      const delayed = Math.max(0, (progress - 0.55) / 0.45);
      inner.style.opacity = Math.max(0, 1 - delayed);
      inner.style.transform = `perspective(900px) translateY(${-delayed * 70}px) rotateX(${delayed * 8}deg)`;
      inner.style.filter = `blur(${delayed * 5}px)`;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [title]);

  if (title) {
    return (
      <div className='ph-wrapper' style={{ height: 'auto' }} ref={wrapperRef}>
        <section className='platform-hero' style={{ position: 'relative', height: 'auto', minHeight: '50vh' }}>
          <div className='ph-inner' ref={innerRef}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
              <div style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--accent)' }}>{title}</div>
              <h2>{highlight}</h2>
              {text && <p style={{ fontSize: '18px', color: 'var(--text-2)', maxWidth: '560px', lineHeight: 1.6, fontWeight: 300 }}>{text}</p>}
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className='ph-wrapper' ref={wrapperRef}>
      <section className='platform-hero'>
        <div className='ph-inner' ref={innerRef}>
          <h2>See the platform<br />in action</h2>
          <div className='ph-cue'>
            <span>Scroll to explore</span>
            <svg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M12 5v14M5 12l7 7 7-7' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PlatformHero;
